import * as React from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Typography } from "@mui/material";
import Slide from "@mui/material/Slide";

const ListCard = (props) => {
  return (
    <Slide direction="up" timeout={500} in={true} mountOnEnter unmountOnExit>
      <Box
        sx={{
          width: "100%",
          border: 1,
          borderColor: "#D9D9D9",
          borderRadius: 15,
          mb: 1,
        }}
      >
        <List
          sx={{
            py: 0,
            px: 1,
            minHeight: "9vh",
            maxHeight: "auto",
            display: "flex",
            background: "linear-gradient(to bottom, rgba(30,87,153,1) 0%,rgba(41,137,216,1) 50%,rgba(32,124,202,1) 51%,rgba(125,185,232,1) 100%)",
            justifyContent: "center",
            alignItems: "center",
            "@media (min-width: 1636px)": { minHeight: "6vh" },
          }}
        >
          <ListItem
            disablePadding
            sx={{ my: 0 }}
            secondaryAction={
              <IconButton
                edge="end"
                au6ria-label="comments"
                sx={{ color: "#FFFFFF" }}
              >
                <KeyboardArrowRightIcon
                  sx={{
                    "@media (min-width: 1636px)": {
                      fontSize: "2rem",
                    },
                  }}
                />
              </IconButton>
            }
            onClick={() => {
              props.press();
            }}
          >
            <ListItemButton sx={{ borderRadius: 15 }}>
              <ListItemText>
                <Typography
                  sx={{
                    color: "#FFFFFF",
                    fontWeight: "500",
                    "@media (min-width: 1636px)": {
                      fontSize: "1.4rem",
                    },
                  }}
                >
                  <span
                    dangerouslySetInnerHTML={{
                      __html: props.text
                        ? props.text
                            .replaceAll("$$", "</b><br>")
                            .replaceAll("$", "<b>")
                        : "",
                    }}
                  ></span>
                </Typography>
              </ListItemText>
            </ListItemButton>
          </ListItem>
        </List>
      </Box>
    </Slide>
  );
};
export default ListCard;
